const trackRudderstackEvent = (eventType, rest) => {
  window.rudderanalytics.track(eventType, rest);
};

export default trackRudderstackEvent;
